import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-collapsible-card',
  template: `
    <mat-expansion-panel
      class="mt-3 mx-3"
      [hideToggle]="true"
      (opened)="onOpened()"
      (closed)="onClosed()"
      [expanded]="open"
    >
      <mat-expansion-panel-header
        class="px-0 align-items-stretch"
        [collapsedHeight]="descriptionHeight || '40px'"
        [expandedHeight]="descriptionHeight || '40px'"
      >
        <mat-panel-title class="mx-0">
          <mat-icon *ngIf="!open" [inline]="true" aria-hidden="false" aria-label="expand panel">chevron_right</mat-icon>
          <mat-icon *ngIf="open" [inline]="true" aria-hidden="false" aria-label="collapse panel">expand_more</mat-icon>
        </mat-panel-title>

        <mat-panel-description class="mx-0">
          <ng-container *ngTemplateOutlet="description ? description : defaultDescription"></ng-container>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div *ngIf="open" class="card-content-size">
        <ng-container *ngTemplateOutlet="content ? content : defaultContent"></ng-container>
      </div>
    </mat-expansion-panel>

    <ng-template #defaultDescription>No Description</ng-template>
    <ng-template #defaultContent>No Content</ng-template>
  `,
  styles: [
    `
      @import '../../../../assets/sass/material/theme';

      .mat-expansion-panel {
        border-radius: 0;
      }

      .mat-icon.mat-icon-inline {
        font-size: 40px;
      }

      .mat-expansion-panel-header,
      .mat-expansion-panel-header:focus,
      .mat-expansion-panel-header:hover {
        background-color: $mdc-theme-secondary !important;
        margin-left: 0;
        margin-right: 0;
      }

      .mat-expansion-panel-header-title {
        background-color: $lighter-blue;
        color: white;
        width: 40px;
        max-width: 40px;
      }

      .mat-expansion-panel-header-description {
        color: white;
        /* Fix a hidden toggle span added with Angular Material v14 */
        margin-right: -8px !important;
      }

      .card-content-size {
        overflow-y: auto;
        overflow-x: hidden;
      }
    `,
  ],
})
export class CollapsibleCardComponent {
  @Input() open = true;
  @Output() opened: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() description: TemplateRef<any>;
  @Input() content: TemplateRef<any>;

  @Input() descriptionHeight: string;

  constructor() {}

  onOpened() {
    this.open = true;
    this.opened.emit(this.open);
  }

  onClosed() {
    this.open = false;
  }
}
